
// export const API_URL =  'http://localhost:3003/api/v1/';
export const API_URL = 'https://support-admin-api.app.avtodel.com/api/v1/';
